(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MnemonicWord", [], factory);
	else if(typeof exports === 'object')
		exports["MnemonicWord"] = factory();
	else
		root["MnemonicWord"] = factory();
})(this, function() {
return 